var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.727 17.805-3.907-3.907c-.195-.156-.43-.273-.664-.273h-.625a8.145 8.145 0 0 0 1.719-5C16.25 4.172 12.578.5 8.125.5 3.633.5 0 4.172 0 8.625a8.119 8.119 0 0 0 8.125 8.125 8.073 8.073 0 0 0 5-1.719v.664c0 .235.078.47.273.664l3.868 3.868c.39.39.976.39 1.328 0l1.093-1.094c.391-.352.391-.938.04-1.328Zm-11.602-4.18c-2.773 0-5-2.227-5-5 0-2.734 2.227-5 5-5 2.734 0 5 2.266 5 5 0 2.773-2.266 5-5 5Z",
    fill: "currentColor"
  })));
};
export default SvgSearch;